import { useQuery, UseQueryResult } from '@tanstack/react-query';

import getLeads from '@/actions/zee/getLeads';
import { LeadsApiResponse } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetLeadsParams {
  page?: number;
  limit?: number;
}

export interface UseGetLeadsProps {
  result: ApiResponse<LeadsApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  isRefetching: boolean;
  refetch: () => void;
}

export const useGetLeads = (
  params: UseGetLeadsParams = {}
): UseGetLeadsProps => {
  const { page = 1, limit = 20 } = params;

  const query: UseQueryResult<ApiResponse<LeadsApiResponse>, Error> = useQuery({
    queryKey: ['consultant-leads', page, limit],
    queryFn: () => getLeads({ page, limit }),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
};
